import {
  createFileName,
  createUUIDName,
  extractFileExtension,
  fileName,
  generateUniqueString,
  getAlbumNameKey,
  limitFileNameLength,
  s3Upload,
  sanitizeNameComponent,
  validateFormName,
} from "@/util/s3";

export default {
  computed: {
    albumNameKey() {
      return getAlbumNameKey();
    },
  },
  methods: {
    async s3Upload(file, newName) {
      return s3Upload(file, newName, this.albumNameKey);
    },
    createUUIDName,
    fileName,
    createFileName,
    validateFormName,
    extractFileExtension,
    generateUniqueString,
    sanitizeNameComponent,
    limitFileNameLength,
  },
};
